<template>
  <svg
    :width="width || '19'"
    height="11"
    viewBox="0 0 19 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.793 0.439453L18.2072 1.85367L9.50008 10.5608L0.792969 1.85367L2.20718 0.439453L9.50008 7.73235L16.793 0.439453Z"
      :fill="fill || 'white'"
    />
  </svg>
</template>

<script>
export default {
  props: ['width', 'fill'],
};
</script>

<style lang="scss" scoped></style>
